import AppLink from "../router/app-link";
import { ReactNode } from "react";

export interface INavbarBrand {
  children?: ReactNode;
  className: string;
}
function NavbarBrand({ children, className }: INavbarBrand) {
  return (
    <AppLink className={className} to={"/"}>
      {children}
    </AppLink>
  );
}

export default NavbarBrand;
